import React from "react";
import "./PromoInfo.css";

const showCustomAlert = (promoCode) => {
  const alertBox = document.createElement("div");
  alertBox.className = "custom-alert";
  const strong = document.createElement("strong");
  strong.textContent = "Copied: ";
  alertBox.appendChild(strong);
  alertBox.appendChild(document.createTextNode(promoCode));

  document.body.appendChild(alertBox);

  setTimeout(() => {
    alertBox.classList.add("fade-out");
    setTimeout(() => alertBox.remove(), 500);
  }, 2000);
};

const copyPromoCode = (promoCode) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(promoCode)
      .then(() => showCustomAlert(promoCode))
      .catch(() => {});
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = promoCode;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    showCustomAlert(promoCode);
  }
};

const PromoInfo = ({ promoInfo, salePrice, compact = false }) => {
  if (!promoInfo || !salePrice) return null;

  try {
    const promoInfoFixed =
      typeof promoInfo === "string" ? promoInfo.replace(/'/g, '"') : promoInfo;
    const parsedPromo =
      typeof promoInfoFixed === "string"
        ? JSON.parse(promoInfoFixed)
        : promoInfoFixed;

    if (
      !parsedPromo.code_mini_spend ||
      !parsedPromo.code_value ||
      !parsedPromo.promo_code
    ) {
      return null;
    }

    const buyQuantity = Math.ceil(
      (parseFloat(parsedPromo.code_mini_spend) * 100) / salePrice
    );
    const discountMatch = parsedPromo.code_value.match(/(\d+(\.\d+)?)/g);
    const discountAmount = discountMatch
      ? Math.round(parseFloat(discountMatch[1]) * 100)
      : 0;

    const prefix = compact ? "promo-compact" : "promo";

    return (
      <div className={`${prefix}-container`}>
        <p className={`${prefix}-info`}>
          Buy {buyQuantity} {compact ? "" : "-> "}Save {discountAmount} ({parsedPromo.code_quantity} left)
        </p>
        <button
          className={`${prefix}-copy-btn`}
          onClick={(e) => {
            e.stopPropagation();
            copyPromoCode(parsedPromo.promo_code);
          }}
        >
          {compact ? "Code" : "Copy Code"}
        </button>
      </div>
    );
  } catch (error) {
    return null;
  }
};

export default PromoInfo;
